module.exports = __webpack_public_path__ + "static/media/vinkompassen-logo.99354b14.svg";